import { createFileRoute } from '@tanstack/react-router'
import { FileLock2 } from 'lucide-react'
import { MyDataScreen } from '@/screens/me/SCR-125-my-data'

export const Route = createFileRoute('/_app/me/data')({
  staticData: { screen: { id: 'SCR-125', title: 'My data and privacy', group: 'Me', order: 7, eyebrow: 'Your rights', description: 'Download everything ESM holds about you, or ask for it to be erased.', icon: FileLock2 } },
  component: MyDataScreen,
})
